module.exports = __webpack_public_path__ + "img/template.889f06ea.svg";